/**
 * @file Создание папки по существующему HTTP-протоколу.
 *
 * До запроса проверяется имя. Ошибки преобразуются в короткие коды переводов;
 * POST не повторяется автоматически при потере ответа.
 */
import { b64Encode } from '../../services/encoding.ts'
import { makeTunnelRequest } from '../../services/request.ts'
import { CreateFolderError, validateFolderName } from './folderName.ts'

export async function createFolder({
    currentFolder,
    folderName,
    boxID,
    token,
    signal,
}: {
    currentFolder: string
    folderName: string
    boxID: string
    token: string
    signal?: AbortSignal
}): Promise<void> {
    const error = validateFolderName(folderName, new Set())
    if (error) throw new CreateFolderError(error)

    const response = await makeTunnelRequest({
        path: '/folder',
        boxID,
        token,
        opts: {
            method: 'POST',
            headers: {
                'x-folder-path': b64Encode(
                    `${currentFolder.replace(/\/$/, '')}/${folderName.trim()}`,
                ),
            },
            signal,
        },
    })
    if (response.ok) return

    if (response.status === 409) throw new CreateFolderError('alreadyExists')

    if (response.status === 400 || response.status === 422)
        throw new CreateFolderError('invalidName')

    if (response.status === 401 || response.status === 403)
        throw new CreateFolderError('forbidden')

    if (response.status === 404)
        throw new CreateFolderError('parentUnavailable')

    throw new CreateFolderError('unconfirmed')
}
